import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loginText" }, "登录入口", -1)
const _hoisted_3 = { class: "captcha-input" }
const _hoisted_4 = ["src"]

import { ref, reactive } from 'vue'
import router from '../../router'
import md5 from 'js-md5';
import { layer } from '@layui/layer-vue'
import {login,getCaptcha} from '../../api'
import { setToken,removeToken,setUserName } from '../../utils/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const captchaSrc=ref("")
const  reloadCaptcha=function () {
    getCaptcha().then((res: any) => {
        console.log(res)
        if (res!=""&&res.code == 0) {  
            captchaSrc.value=res.data
        }
    })
    
}

reloadCaptcha();

const user = reactive({
    userName: "",
    password: "",
    code:"",
    codeKey:""

})

removeToken(); 
const submit2 = function () {
     if(user.userName.length==0||user.password.length==0){ 
        layer.msg("账号或者密码不能为空", { icon : 2, time: 1000}) 
        return false;
     }

     user.codeKey=md5.md5(captchaSrc.value); 
    login(JSON.stringify(user)).then((res: any) => {
        if (res!=""&&res.code == 0) { 
            setUserName(user.userName);
            setToken(res.data);
            layer.msg("登录成功", { icon : 1, time: 1000})
            router.push({ path: '/' }) 
        }  
    })

};


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_panel = _resolveComponent("lay-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lay_panel, { style: {"border-radius":"5px","border-style":"none","background-color":"transparent","backdrop-filter":"blur(20px)","min-width":"max-content","box-shadow":"0 0.3px 0.7px rgba(0, 0, 0, 0.126), 0 0.9px 1.7px rgba(0, 0, 0, 0.179), 0 1.8px 3.5px rgba(0, 0, 0, 0.224), 0 3.7px 7.3px rgba(0, 0, 0, 0.277), 0 10px 20px rgba(0, 0, 0, 0.4)"} }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_lay_form, {
          model: user,
          pane: true,
          style: {"padding":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_form_item, {
              label: "账户",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.userName) = $event)),
                  placeholder: "请输入账号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.password) = $event)),
                  type: "password",
                  placeholder: "请输入密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "验证码",
              class: "captcha-form-item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_lay_input, {
                    modelValue: user.code,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.code) = $event)),
                    placeholder: "请输入验证码",
                    class: "captcha-input-box"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("img", {
                    src: 'data:image/jpeg;base64,'+captchaSrc.value,
                    onClick: reloadCaptcha,
                    class: "captcha-img"
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, { style: {"padding-left":"7px","padding-right":"5px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_button, {
                  type: "primary",
                  onClick: submit2,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})